import { Spacer } from '@spritz-finance/ui'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useScreenSize } from '../../../../context/useScreenSize'
import { BillCard } from './BillCard'
import { Bill, Subscription } from './Bills'
import { ChangeBillTypeDialog } from './ChangeBillTypeDialog'
import { RemoveBillDialog } from './RemoveBillDialog'
import { RenameBillDialog } from './RenameBillDialog'
import { BankAccount } from '../../../offramp/components/BankAccounts'
import { AccountCard } from '../../../offramp/components/accounts/AccountCard'
import { RenameAccountDialog } from '../../../offramp/components/accounts/RenameAccountDialog'
import { RemoveAccountDialog } from '../../../offramp/components/accounts/RemoveAccountDialog'
import { DeleteSubscriptionDialog } from './DeleteSubscriptionDialog'

type BillsListProps = { bills: Bill[]; subscriptions: Subscription[]; bankAccounts: BankAccount[] }

const ListContainer = styled.div`
    padding-bottom: 72px;
`
export const BillsList = ({ bills, subscriptions, bankAccounts }: BillsListProps) => {
    const { isDesktop } = useScreenSize()
    const [billToRemove, setBillToRemove] = useState<Bill | null>(null)
    const [billToRename, setBillToRename] = useState<Bill | null>(null)
    const [changeBillType, setChangeBillType] = useState<Bill | null>(null)
    const [accountToRemove, setAccountToRemove] = useState<BankAccount | null>(null)
    const [accountToRename, setAccountToRename] = useState<BankAccount | null>(null)
    const [subscriptionToDelete, setSubscriptionToDelete] = useState<Subscription | null>(null)

    return (
        <>
            <ListContainer>
                {bills.map((bill) => (
                    <React.Fragment key={bill.id}>
                        <BillCard
                            bill={bill}
                            subscriptions={subscriptions}
                            onRemoveBill={(bill) => setBillToRemove(bill)}
                            onRenameBill={(bill) => setBillToRename(bill)}
                            onChangeBillType={(bill) => setChangeBillType(bill)}
                            onDeleteSubscription={(subscription) =>
                                setSubscriptionToDelete(subscription)
                            }
                        />
                        {isDesktop ? <Spacer height={32} /> : <Spacer height={16} />}
                    </React.Fragment>
                ))}
                {bankAccounts.map((account) => (
                    <React.Fragment key={account.id}>
                        <AccountCard
                            account={account}
                            onRemoveAccount={(account) => setAccountToRemove(account)}
                            onRenameAccount={(account) => setAccountToRename(account)}
                        />
                        {isDesktop ? <Spacer height={32} /> : <Spacer height={16} />}
                    </React.Fragment>
                ))}
            </ListContainer>
            <RemoveBillDialog bill={billToRemove} onClose={() => setBillToRemove(null)} />
            <RenameBillDialog bill={billToRename} onClose={() => setBillToRename(null)} />
            <ChangeBillTypeDialog bill={changeBillType} onClose={() => setChangeBillType(null)} />
            <DeleteSubscriptionDialog
                subscription={subscriptionToDelete}
                onClose={() => setSubscriptionToDelete(null)}
            />
            <RenameAccountDialog
                account={accountToRename}
                onClose={() => setAccountToRename(null)}
            />
            <RemoveAccountDialog
                account={accountToRemove}
                onClose={() => setAccountToRemove(null)}
            />
        </>
    )
}
